import { render, staticRenderFns } from "./UpdateBusiness.vue?vue&type=template&id=628b9b40"
import script from "./UpdateBusiness.vue?vue&type=script&lang=js"
export * from "./UpdateBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports